import { PUT_STAFF_ERROR, PUT_STAFF_START, PUT_STAFF_SUCCESS } from '../../types';

export default function put_staff(state, action) {
  switch (action.type) {
    case PUT_STAFF_START:
      return { ...state };
    case PUT_STAFF_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case PUT_STAFF_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}
